import { EnumColor } from '@40seas/frontend/common/providers';
import { PaymentMethodStatus } from '@40seas/models';

export const paymentMethodStatusColorMapping = {
    [PaymentMethodStatus.Active]: 'success',
    [PaymentMethodStatus.Inactive]: 'error',
    [PaymentMethodStatus.PendingMandate]: 'warning',
    [PaymentMethodStatus.Pending]: 'default',
} as { [key in PaymentMethodStatus]: EnumColor };
